/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flash-messages[_ngcontent-%COMP%]{margin-bottom:20px}\n/*# sourceMappingURL=flash-messages.component.css.map*/"];
export { styles as styles };
